module.exports = __webpack_public_path__ + "static/media/IMG20260125161540.123546b4.jpg";